export enum VatDeclarationSubSteps {
    MAIN = 'main',
    VAT_DECLARATION = 'vatDeclaration',
}
